<template>
  <div
    v-if="ready && toggles.length > 0"
    class="toggles"
    :class="{ 'no-slides': toggles.length <= 3 }"
    :id="id"
  >
    <template v-if="toggles.length > 3">
      <VueSlickCarousel v-bind="slideOptions">
        <div
          v-for="(toggle, i) in toggles"
          :key="i"
          class="toggle-item slide"
          :class="{ active: !!toggle.active }"
          @click="goToUrl(toggle.url)"
        >
          <img :src="toggle.image" :alt="toggle.name" />
        </div>
        <template slot="prevArrow">
          <div class="toggle-arrow toggle-prev">
            <icon icon="arrow-left" class="icon" />
          </div>
        </template>
        <template slot="nextArrow">
          <div class="toggle-arrow toggle-next">
            <icon icon="arrow-right" class="icon" />
          </div>
        </template>
      </VueSlickCarousel>
    </template>
    <template v-else>
      <div
        v-for="(toggle, i) in toggles"
        :key="i"
        class="toggle-item"
        :class="{ active: !!toggle.active }"
        @click="goToUrl(toggle.url)"
      >
        <img :src="toggle.image" :alt="toggle.name" />
      </div>
    </template>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import Str from "helpers/Str";

export default {
  components: { VueSlickCarousel },

  props: {
    toggles: { type: Array, default: () => [] },
  },

  data() {
    return {
      id: `toggles-${Str.random()}`,
      imagesLoaded: 0,
      ready: false,
    };
  },

  computed: {
    initialSlide() {
      var slide = 0;
      this.toggles.forEach((toggle, index) => {
        if (toggle.active) {
          slide = index;
        }
      });
      return slide;
    },
    slideOptions() {
      return {
        centerMode: true,
        dots: false,
        initialSlide: this.initialSlide,
        slidesToShow: 3,
        variableWidth: true,
      };
    },
  },

  watch: {
    imagesLoaded(count) {
      if (count >= this.toggles.length) {
        this.ready = true;
        this.$nextTick(() => {
          this.vueCarouselWidthFix();
        });
      }
    },
  },

  methods: {
    vueCarouselWidthFix() {
      var width = 0;
      $(`#${this.id} .slick-slide`).each((i, elem) => {
        width += $(elem).width();
      });
      $(`#${this.id} .slick-track`).width(width);
    },
  },

  created() {
    // preload toggle images
    if (this.toggles.length > 0) {
      this.toggles.forEach((toggle, i) => {
        var img = new Image();
        img.onload = () => {
          this.imagesLoaded = this.imagesLoaded + 1;
        };
        img.src = toggle.image;
      });
    }
  },
};
</script>
